import React from 'react';
import { Check } from 'lucide-react';

const points = [
  'Avoid fake/junk/spam users.',
  'Keep it real and meaningful.',
  'Serious users only = Better experience.',
  'Helps us verify every service provider properly.',
];

const WhyPremium = () => {
  return (
    <section className="py-16 md:py-24 bg-slate-800/50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-heading font-bold text-2xl sm:text-3xl text-white text-center mb-10">
          Why Premium-Only?
        </h2>
        <div className="max-w-xl mx-auto space-y-4">
          {points.map((text, i) => (
            <div key={i} className="flex items-start gap-3">
              <Check className="h-5 w-5 text-brand-pink shrink-0 mt-0.5" />
              <span className="text-slate-300">{text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyPremium;
